import React from "react";
import type { PaymentGateway } from "@/src/shared/features/payment";

/** The app's `PaymentGatewayCard`: the method the guest will pay with, marked selected. */
const PaymentGatewayCard: React.FC<{
  gateway: PaymentGateway;
  savedBkashNumber: string;
}> = ({ gateway, savedBkashNumber }) => (
  <div className="flex items-center gap-3 rounded-xl border border-[#EBEBEB] p-4">
    <img
      src={`/icons/confirm-pay/${gateway === "ssl" ? "payment_other_methods" : "payment_bkash"}.png`}
      alt=""
      className="h-5 w-5 shrink-0 rounded object-cover"
    />
    <span className="min-w-0 flex-1 text-14 text-ink">
      {gateway === "savedBkash"
        ? savedBkashNumber
        : gateway === "bkash"
          ? "bKash"
          : "Other payment methods"}
    </span>
    <img
      src="/icons/confirm-pay/payment_method_selected.svg"
      alt=""
      className="h-5 w-5 shrink-0"
    />
  </div>
);

export default PaymentGatewayCard;
